// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__LnEP6","info":"UpdateTermsInfo_info__2OQB4"};